module.exports = __webpack_public_path__ + "img/new_platform.8247b5bc.png";